import { defineGameCard, drawCards, onResolve } from '../authoring/index.js';
export const RoyalDecreeCard = defineGameCard({
    id: 'royal_decree',
    gameplay: { type: 'SPELL', cost: 3 },
    presentation: {
        name: 'Королевский указ',
        description: 'Возьмите 2 карты.',
        glyph: {
            colors: ['#10213A', '#CE7336', '#FCB856', '#E99844', '#8D62A9'],
            rows: [
                '....................',
                '.........11.........',
                '.....2..1331........',
                '......2.1331.4......',
                '........1341........',
                '........1341........',
                '.....3..1321..4.....',
                '.......133311.......',
                '......13323331......',
                '.....1333322321.....',
                '....133222233331....',
                '....133222222321....',
                '....123322222221....',
                '.....1233223221.....',
                '......123233221.....',
                '......12332221......',
                '.....1533333251.....',
                '.....1555555551.....',
                '.....1111111111.....',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [onResolve(drawCards(2))],
});
//# sourceMappingURL=royal_decree.js.map